function ShimmerBar({ className = "" }) {
  return <div className={`bg-gray-200 rounded ${className}`} />;
}

function OrderRowShimmer() {
  return (
    <div className="w-full flex justify-between bg-white p-4 gap-3 animate-pulse">
      <div className="flex flex-col md:flex-row justify-between flex-1 gap-4 md:gap-2">
        <div className="w-full md:w-[25%] flex flex-col gap-2 px-2">
          <ShimmerBar className="h-3 w-20" />
          <ShimmerBar className="h-4 w-32" />
          <ShimmerBar className="h-3 w-24" />
        </div>
        <div className="hidden md:flex md:w-[15%] flex-col gap-2 px-2">
          <ShimmerBar className="h-3 w-16" />
          <ShimmerBar className="h-4 w-24" />
        </div>
        <div className="hidden md:flex md:w-[15%] flex-col gap-2 px-2">
          <ShimmerBar className="h-3 w-16" />
          <ShimmerBar className="h-4 w-20" />
        </div>
        <div className="hidden md:flex md:w-[15%] flex-col gap-2 px-2">
          <ShimmerBar className="h-3 w-16" />
          <ShimmerBar className="h-4 w-24" />
        </div>
        <div className="hidden md:flex md:w-[15%] flex-col gap-2 px-2">
          <ShimmerBar className="h-3 w-12" />
          <ShimmerBar className="h-4 w-20" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-2">
        <ShimmerBar className="h-6 w-20 rounded-md" />
        <ShimmerBar className="h-5 w-5 rounded-full md:hidden" />
      </div>
    </div>
  );
}

export default function OrderListShimmer({ rows = 6 }) {
  return (
    <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-3 p-1">
      {[...Array(rows)].map((_, index) => (
        <OrderRowShimmer key={index} />
      ))}
    </div>
  );
}
